import { TrackData } from '@shared/interfacres/track';

export const increaseCounter = (id: number, tracks: Partial<TrackData>[] | TrackData[]) => {
  return tracks.map(track => {
    if (track.id === id) {
      return {
        ...track,
        downloadsCount: track.downloadsCount === undefined ? 1 : track.downloadsCount += 1
      }
    } else {
      return track
    }
  })
}

export const decreaseCounter = (id: number, tracks: Partial<TrackData>[] | TrackData[]) => {
  return tracks.map(track => {
    if (track.id === id) {
      return {
        ...track,
        downloadsCount: track.downloadsCount === undefined ? 0 : track.downloadsCount -= 1
      }
    } else {
      return track
    }
  })
}

export const markAsListened = (id: number, tracks: Partial<TrackData>[] | TrackData[]) => {
  return tracks.map(track => {
    if (track.id === id && track.previewed?.length === 0) {
      return {
        ...track,
        previewed: [{id: 1}]
      }
    } else {
      return track
    }
  })
}
